import { getFirestore, doc, setDoc } from "firebase/firestore";
import { app } from "../firebase";

// Always use production Firebase Functions (no emulators), matching the Hub new-account flow.
const SERVER_URL = "https://us-central1-my-tassel.cloudfunctions.net/api";
const GRADUATE_ACCOUNT_TYPE = "Graduate";
const FRIENDS_AND_FAMILY_ACCOUNT_TYPE = "Friends & Family";

const db = getFirestore(app);

const postWelcomeEmail = async (path, userData) => {
	try {
		await fetch(`${SERVER_URL}/${path}`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ userEmail: userData.email, firstName: userData.firstName }),
		});
	} catch (error) {
		console.warn("Welcome email skipped:", error.message);
	}
};

export const sendGraduateWelcomeEmail = (userData) => postWelcomeEmail("send-graduate-welcome-email", userData);

export const sendGenericWelcomeEmail = (userData) => postWelcomeEmail("send-generic-welcome-email", userData);

export const sendAdminNewUserNotification = (userData) => {
	fetch(`${SERVER_URL}/admin-new-user-notification`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({ userData }),
	}).catch((error) => console.log("Admin notification error (non-blocking):", error.message));
};

/** Welcome email + admin notification matching the account type the user ended up with. */
export const sendNewAccountNotifications = (userData) => {
	const isGraduate = userData.accountType === GRADUATE_ACCOUNT_TYPE;
	if (isGraduate) sendGraduateWelcomeEmail(userData);
	else sendGenericWelcomeEmail(userData);
	sendAdminNewUserNotification({ ...userData, accountType: isGraduate ? GRADUATE_ACCOUNT_TYPE : FRIENDS_AND_FAMILY_ACCOUNT_TYPE });
};

/**
 * Closes out a brand-new account (clears `newAccount`). Accounts that already have pages were set up
 * another way and are cleared silently; everyone else gets their welcome email and admin notification.
 */
export const finishNewAccountSetup = async (userData) => {
	await setDoc(doc(db, "users", userData.email), { newAccount: false }, { merge: true });
	const alreadyHasPages = Boolean(userData.pages?.events || userData.pages?.registry);
	if (!alreadyHasPages) sendNewAccountNotifications(userData);
};
